import 'regenerator-runtime/runtime';
import { SagaIterator } from 'redux-saga';
import { put, select, takeEvery } from 'redux-saga/effects';
import { AngebotsId, GlobalAction, GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { childKeyOf, listedChildKeys } from '../models/childKeys';
import { TgvActions } from '../tgvActions';

export function* watchTiergruppeEdit(): SagaIterator {
  yield takeEvery(
    GlobalActions.TIERGRUPPE_ANGEBOT_EDIT_REQUESTED,
    safeSaga(tiergruppeEditSaga, App.TGV),
  );
}

export function* tiergruppeEditSaga(action: GlobalAction<AngebotsId>): SagaIterator {
  const key = childKeyOf(action.payload);
  const { tiergruppe, transientState }: IAppState = yield select();
  if (
    key === null ||
    !listedChildKeys(tiergruppe).includes(key) ||
    transientState.children.pendingDeletion.includes(key) ||
    transientState.children.creating.includes(key)
  ) {
    return;
  }
  yield put(new TgvActions().angebotEditMarked(key));
}
